import { createEnv } from "@t3-oss/env-nextjs";
import { z } from "zod";

export const env = createEnv({
  /**
   * Specify your server-side environment variables schema here. This way you can ensure the app
   * isn't built with invalid env vars.
   */
  server: {
    DATABASE_URL: z.string().url(),
    NODE_ENV: z.enum(["development", "test", "production"]),
    NEXTAUTH_SECRET:
      process.env.NODE_ENV === "production"
        ? z.string().min(1)
        : z.string().min(1).optional(),
    // Add `.min(1) on ID and SECRET if you want to make sure they're not empty
    SQUARE_ACCESS_TOKEN: z.string().min(1),
    SQUARE_ENVIRONMENT: z.enum(["sandbox", "production"]),
    SQUARE_DONATION_SUB_PLAN_ID: z.string().min(1),
    SQUARE_PREMIUM_MEMBERSHIP_ITEM_ID: z.string().min(1),
    SQUARE_PREMIUM_MEMBERSHIP_SUB_PLAN_ID: z.string().min(1),
    NEXT_PUBLIC_ALLOW_DELETE_SQUARE_PROFILE: z.string().min(1),
    SENTRY_ENVIRONMENT: z.string().optional(),
    MIXPANEL_TOKEN: z.string().min(1),
  },

  /**
   * Specify your client-side environment variables schema here. This way you can ensure the app
   * isn't built with invalid env vars. To expose them to the client, prefix them with
   * `NEXT_PUBLIC_`.
   */
  client: {
    NEXT_PUBLIC_SQUARE_APP_ID: z.string().min(1),
    NEXT_PUBLIC_SQUARE_LOCATION_ID: z.string().min(1),
    NEXT_PUBLIC_ALLOW_DELETE_SQUARE_PROFILE: z.string().min(1),
  },

  /**
   * You can't destruct `process.env` as a regular object in the Next.js edge runtimes (e.g.
   * middlewares) or client-side so we need to destruct manually.
   */
  runtimeEnv: {
    DATABASE_URL: process.env.DATABASE_URL,
    NODE_ENV: process.env.NODE_ENV,
    NEXTAUTH_SECRET: process.env.NEXTAUTH_SECRET,
    NEXT_PUBLIC_SQUARE_APP_ID: process.env.NEXT_PUBLIC_SQUARE_APP_ID,
    NEXT_PUBLIC_SQUARE_LOCATION_ID: process.env.NEXT_PUBLIC_SQUARE_LOCATION_ID,
    SQUARE_ACCESS_TOKEN: process.env.SQUARE_ACCESS_TOKEN,
    SQUARE_ENVIRONMENT: process.env.SQUARE_ENVIRONMENT,
    SQUARE_DONATION_SUB_PLAN_ID: process.env.SQUARE_DONATION_SUB_PLAN_ID,
    SQUARE_PREMIUM_MEMBERSHIP_ITEM_ID:
      process.env.SQUARE_PREMIUM_MEMBERSHIP_ITEM_ID,
    SQUARE_PREMIUM_MEMBERSHIP_SUB_PLAN_ID:
      process.env.SQUARE_PREMIUM_MEMBERSHIP_SUB_PLAN_ID,
    NEXT_PUBLIC_ALLOW_DELETE_SQUARE_PROFILE:
      process.env.NEXT_PUBLIC_ALLOW_DELETE_SQUARE_PROFILE,
    SENTRY_ENVIRONMENT: process.env.SENTRY_ENVIRONMENT,
    MIXPANEL_TOKEN: process.env.MIXPANEL_TOKEN,
  },
  /**
   * Run `build` or `dev` with `SKIP_ENV_VALIDATION` to skip env validation.
   * This is especially useful for Docker builds.
   */
  skipValidation: !!process.env.SKIP_ENV_VALIDATION,
});
